import { render, staticRenderFns } from "./ArrowSplash.vue?vue&type=template&id=2ce6cb88"
import script from "./ArrowSplash.vue?vue&type=script&lang=js"
export * from "./ArrowSplash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports